 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		21: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vsf-category~vsf-home~vsf-my-account~vsf-product~vsf-search-panel~vsf-search-panel-desktop~vsf-searc~49c21426","1":"vendors~vue-carousel","2":"vendors~vsf-wp-posts-index~vsf-wp-posts-show~vsf-wp-press-index~vsf-wp-press-show","3":"login~vsf-checkout~vsf-layout-default","4":"vendors~vsf-checkout~vsf-microcart~vsf-product","5":"vsf-layout-default~vsf-layout-empty~vsf-layout-minimal","6":"vendors~bodybuilder~vsf-product","7":"vendors~vsf-product~vue-vimeo-player","8":"vsf-checkout~vsf-microcart","9":"vsf-wp-posts-show~vsf-wp-press-show","12":"SwipeActions","14":"bodybuilder","15":"dayjs-locales-de","16":"dayjs-locales-en","17":"dayjs-locales-nl","18":"dayjs-locales-pl","19":"dayjs-locales-sv","20":"login","23":"vendors~vsf-checkout","24":"vendors~vsf-graphql","25":"vendors~vsf-layout-default","26":"vsf-career","27":"vsf-category","28":"vsf-checkout","29":"vsf-cms","30":"vsf-error","31":"vsf-head-img-banners-de_main-image-json","32":"vsf-head-img-banners-de_promoted_offers-json","33":"vsf-head-img-banners-it_main-image-json","34":"vsf-head-img-banners-it_promoted_offers-json","35":"vsf-head-img-main-image-json","36":"vsf-head-img-promoted_offers-json","37":"vsf-head-img-slider-json","38":"vsf-home","39":"vsf-languages-modal","40":"vsf-layout-default","41":"vsf-layout-empty","42":"vsf-layout-minimal","43":"vsf-microcart","44":"vsf-my-account","45":"vsf-not-found","46":"vsf-order-confirmation","47":"vsf-placepozniej","48":"vsf-product","49":"vsf-product-gallery-carousel","50":"vsf-product-gallery-overlay","51":"vsf-reset-password","52":"vsf-search-adapter-api-search-query-searchAdapter","53":"vsf-search-adapter-api-searchAdapter","54":"vsf-search-adapter-graphql-searchAdapter","55":"vsf-search-panel","56":"vsf-search-panel-desktop","57":"vsf-search-panel-mobile","58":"vsf-selling","59":"vsf-sidebar-menu","60":"vsf-typ","61":"vsf-typ-sale","62":"vsf-wishlist","63":"vsf-wp-posts-index","64":"vsf-wp-posts-show","65":"vsf-wp-press-index","66":"vsf-wp-press-show"}[chunkId]||chunkId) + "." + {"0":"62eb3d9513e98882fffe","1":"842c1f15b63ff620a585","2":"316a75dc5717210b48c1","3":"47a4f3df2535ccd2585a","4":"1d6a5b53059deef4727e","5":"4f135ca30a36629c70f0","6":"2eaf4ae71f9653a98e15","7":"f2365c1bd5cdab13522f","8":"2aaa1c68abb6abd57285","9":"4fd646dddd7d7fa4fdd7","10":"6613aa5e082bd26c0c3d","11":"0ab199c9f9bcea3fec63","12":"aa4595155aefad903cd6","14":"1eec1f2c40061c2ebcaf","15":"20a59dfa5dacabe30878","16":"1df4f4e8caf67c523238","17":"5f0e5a57ad11cb241e9b","18":"20989d5644b13b415442","19":"f3a256b3f62a1be2e0d7","20":"174e680f1cfaeee978d6","23":"fee8f1f31bdf8c835c5a","24":"04b8ae30e00c5ccbb300","25":"80e396d5f2e3dd806e02","26":"0820db9a4a25cc67753d","27":"22b6d5ff9d68066ed68e","28":"75b54e524d8808754f32","29":"704ed76e59f327fa0857","30":"960f8a133e59571bf24e","31":"f6eb35c9d21109ce0938","32":"258f403dcfe226a6d66a","33":"c2cfe348235cfd6703a5","34":"3eadd5e5240ee25c70d5","35":"3121d44564f0c34d3704","36":"734f92476b11a3e749d9","37":"58fff76587db5443b0d7","38":"0701718bec6b7589aa57","39":"6413a3e1ff6679bb0542","40":"0aa6ee5e190b9e223fc6","41":"cf079bca77ce824d107e","42":"32e365ff9b7f4cc4634d","43":"b775ff48e78003349602","44":"a9c431961848653292a5","45":"296a115e2ca5dcd2f2af","46":"cb82a6038830ab806234","47":"e7575f4d29be2d1d7e1a","48":"d73aab8bd47e55f63a5e","49":"f3f291d05db45335f99d","50":"b48942c24af93d411d1e","51":"9795309765f99ce34897","52":"86c395505f15a8ff28d9","53":"5ffa337ee7ba0869d354","54":"37b3412a3aa3028f7226","55":"4faed99b67bbf9096858","56":"725ca9095e993aa86183","57":"90fb6fd64d5b6dc72c0d","58":"6838dbad3a03b691ce80","59":"8084beaf0bc4bef8dfd0","60":"77904c628db1550a78b1","61":"d5e72f7b41376c7ddc17","62":"38e6219e9f3d0e59e313","63":"45288ed4fbb45937b3f1","64":"2af4d1b9e45ad25c693e","65":"ee4520b054fac5a4dd8b","66":"fba213627a52b9b369d6","67":"5488309186e1e980e854","68":"cc288cf2dbc64e1a3af7","69":"38b2d9854d454d9d1ff2","70":"991b32991646e7b3e022","71":"8d5b331057b4ba9cefd3","72":"b94a2a6acde719933459","73":"cff7326ba1c920e4a5f4","74":"b2b004faa64b29319c79","75":"b5233deb3914989d8d8a","76":"251dfc5cd00913aeb53d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}

 		// chunk preloadng for javascript

 		var chunkPreloadMap = {
 			"40": [
 				4,
 				8,
 				43,
 				0,
 				62,
 				59
 			],
 			"43": [
 				12
 			]
 		};

 		var chunkPreloadData = chunkPreloadMap[chunkId];
 		if(chunkPreloadData) {
 			chunkPreloadData.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					link.charset = 'utf-8';
 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "preload";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
